import {IBid, IContractBid, IOtherBid} from "../Types/interface";

export function isContractBid(bid: IBid) {
    return (bid as IContractBid).suit !== undefined && (bid as IContractBid).tricks !== undefined;
}

export function isOtherBid(bid: IBid) {
    return (bid as IOtherBid).otherBid !== undefined;
}